/**
 * Created by andrey on 04.05.2021.
 */

const WebViewAudioEngine = function () {
    this.sounds = {};

    this.batch = {};
    this.sendBatch = cleverapps.accumulate(0, this._sendBatch.bind(this));
};

WebViewAudioEngine.prototype._sendBatch = function () {
    const batch = Object.values(this.batch);

    connector.platform.callNative("AudioPlugin.sendBatch", { batch });

    this.batch = {};
};

WebViewAudioEngine.prototype.playMusic = function (url) {
    if (!url) {
        return;
    }

    this.batch.musicAction = { action: "playMusic", url };
    this.sendBatch();
};

WebViewAudioEngine.prototype.stopMusic = function () {
    this.batch.musicAction = { action: "stopMusic" };
    this.sendBatch();
};

// the native audio plugin has no pause, so the music is stopped and started over - returning
// false tells the caller nothing is held and the current disk has to be replayed
WebViewAudioEngine.prototype.pauseMusic = function () {
    this.stopMusic();
    return true;
};

WebViewAudioEngine.prototype.resumeMusic = function () {
    return false;
};

WebViewAudioEngine.prototype.stopSound = function (url) {
    this.batch[`sound_${url}`] = { action: "stopSound", url };
    this.sendBatch();
};

WebViewAudioEngine.prototype.playSound = function (url) {
    if (!url) {
        return;
    }

    this.batch[`sound_${url}`] = { action: "playSound", url };
    this.sendBatch();

    let sound = this.sounds[url];
    if (!sound) {
        sound = this.sounds[url] = new WebViewSound(url);
    }

    sound.play();
};

WebViewAudioEngine.prototype.fade = function (duration, from, to) {
    this.batch.fade = {
        action: "fade", duration, from, to 
    };
    this.sendBatch();
};

WebViewAudioEngine.prototype.isPlaying = function (url) {
    const sound = this.sounds[url];
    return sound && sound.playing();
};

WebViewAudioEngine.prototype.isLoaded = function () {
    return true;
};

WebViewAudioEngine.prototype.unload = function () {
};

WebViewAudioEngine.prototype.mute = function () {
};

WebViewAudioEngine.prototype.unmute = function () {
};

WebViewAudioEngine.prototype.isAudioContextRunning = function () {
    return true;
};

WebViewAudioEngine.prototype.resumeAudioContext = function () {
};

WebViewAudioEngine.IsApplicable = function () {
    // if (connector.platform.oneOf(connector.IOS) && ["mergecraft"].includes(cleverapps.config.name)) {
    //     return false;
    // }

    return (connector.platform.oneOf(connector.IOS, connector.MACOS)
        || connector.info.audioPluginAvailable && connector.platform.oneOf(connector.ANDROID, connector.AMAZON, connector.RUSTORE, connector.DIGITAL))
        && connector.info.isNative && !cc.sys.isNativeFlight;
};